export default __webpack_public_path__ + "static/media/extension_giftcard_silver_w2.5940953a.svg";